"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _LinkCustomParams = _interopRequireDefault(require("MeetingsBase/models/LinkCustomParams"));

var _UserBusyTimes = _interopRequireDefault(require("MeetingsBase/models/UserBusyTimes"));

var _FormPrefills = _interopRequireDefault(require("MeetingsBase/models/FormPrefills"));

var _LinkAvailability = _interopRequireDefault(require("MeetingsBase/models/LinkAvailability"));

var defaults = {
  allUsersBusyTimes: (0, _immutable.List)(),
  bufferTime: 0,
  customParams: new _LinkCustomParams.default(),
  linkId: null,
  linkType: null,
  userId: null,
  offline: false,
  openGates: (0, _immutable.List)(),
  ownerPrioritized: null,
  inactive: false,
  formGuid: null,
  contentTracking: null,
  formPrefills: new _FormPrefills.default(),
  linkAvailability: null,
  portalId: null
};

var PublicAvailabilityInfo = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(PublicAvailabilityInfo, _Record);

  function PublicAvailabilityInfo() {
    (0, _classCallCheck2.default)(this, PublicAvailabilityInfo);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PublicAvailabilityInfo).apply(this, arguments));
  }

  (0, _createClass2.default)(PublicAvailabilityInfo, [{
    key: "updateBusyTime",
    value: function updateBusyTime(jsonUserBusyTimes) {
      var updatedUserBusyTimes = _UserBusyTimes.default.from(jsonUserBusyTimes);

      return this.update('allUsersBusyTimes', function (allUsersBusyTimes) {
        return allUsersBusyTimes.map(function (userBusyTimes) {
          if (userBusyTimes.id === updatedUserBusyTimes.id) {
            return updatedUserBusyTimes;
          }

          return userBusyTimes;
        });
      });
    }
  }], [{
    key: "from",
    value: function from(json) {
      var customParams = _LinkCustomParams.default.from(json.customParams);

      var allUsersBusyTimes = (0, _immutable.List)(json.allUsersBusyTimes.map(function (userBusyTimes) {
        return _UserBusyTimes.default.from(userBusyTimes);
      }));

      var formPrefills = _FormPrefills.default.from(json.formPrefills, customParams.get('formFields'));

      var linkAvailability = _LinkAvailability.default.from(json.linkAvailability);

      return new PublicAvailabilityInfo({
        allUsersBusyTimes: allUsersBusyTimes,
        bufferTime: customParams.meetingBufferTime,
        linkId: json.linkId,
        linkType: json.linkType,
        userId: json.userId,
        customParams: customParams,
        offline: json.isOffline,
        openGates: (0, _immutable.List)(json.openGates),
        ownerPrioritized: json.customParams.ownerPrioritized,
        inactive: json.inactive,
        formGuid: json.formGuid,
        contentTracking: json.contentTracking,
        formPrefills: formPrefills,
        linkAvailability: linkAvailability,
        portalId: json.portalId
      });
    }
  }]);
  return PublicAvailabilityInfo;
}((0, _immutable.Record)(defaults));

exports.default = PublicAvailabilityInfo;
module.exports = exports.default;